import { useState } from 'react';
import Modal from '../base/Modal';
import Button from '../base/Button';
import { Link } from 'react-router-dom';

interface TermsConsentModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
  isSubmitting?: boolean;
  termsVersion: string;
}

export default function TermsConsentModal({
  isOpen,
  onAccept,
  onDecline,
  isSubmitting = false,
  termsVersion
}: TermsConsentModalProps) {
  const [checked, setChecked] = useState(false);

  return (
    <Modal isOpen={isOpen} onClose={onDecline} title="Confirmação de consentimento" size="md">
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          Para continuar usando o Magistral, confirme que leu e aceita os{' '}
          <Link to="/terms-and-privacy" className="text-emerald-600 underline" target="_blank" rel="noopener noreferrer">
            Termos de Uso
          </Link>{' '}e a{' '}
          <Link to="/terms-and-privacy" className="text-emerald-600 underline" target="_blank" rel="noopener noreferrer">
            Política de Privacidade
          </Link>
          .
        </p>
        <p className="text-xs text-gray-500">Versão dos termos: <span className="font-medium">{termsVersion}</span></p>

        <label className="flex items-start gap-3 text-sm text-gray-700">
          <input
            type="checkbox"
            className="mt-0.5 w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span>Eu li e aceito os Termos de Uso e a Política de Privacidade</span>
        </label>

        <div className="flex items-center justify-end gap-3 pt-2">
          <button
            type="button"
            className="text-gray-600 hover:text-gray-800 text-sm"
            onClick={onDecline}
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <Button
            type="button"
            onClick={onAccept}
            disabled={!checked || isSubmitting}
          >
            {isSubmitting ? 'Registrando...' : 'Aceitar e continuar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
